// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-7804efee] {\n  fill: #fff\n}\n.st132[data-v-7804efee] {\n  fill: #ffc489\n}\n", ""]);
// Exports
module.exports = exports;
